// extracted by mini-css-extract-plugin
export default {"FeedbackModal__Box":"vCkUJBvpvnuzAw3oNArM","FeedbackModal__BoxImage":"aE170GzHLb5BVqwDT8WF","FeedbackModal__Close_Icon_div":"KyVYuBVR_vB2HDnPqgpL","FeedbackModal__Close_Icon":"a4mlY5CE3XOOw3yTS_VA","LeaderboradModal__Content":"OSMngesnUzRMhZiRu2JW"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"FeedbackModal__Box\":\"vCkUJBvpvnuzAw3oNArM\",\"FeedbackModal__BoxImage\":\"aE170GzHLb5BVqwDT8WF\",\"FeedbackModal__Close_Icon_div\":\"KyVYuBVR_vB2HDnPqgpL\",\"FeedbackModal__Close_Icon\":\"a4mlY5CE3XOOw3yTS_VA\",\"LeaderboradModal__Content\":\"OSMngesnUzRMhZiRu2JW\"}";
        // 1778765598477
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  